import React, { useEffect, useState } from "react";
import axios from "axios";
import { server } from "../index";
import {
  Container,
  HStack,
  Heading,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react";
import Loader from "./Loader";
import Error from "./Error";
import { motion } from "framer-motion";

const Exchanges = () => {
  const [exchanges, setExchanges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    const fetchExchanges = async () => {
      try {
        const { data } = await axios.get(`${server}/exchanges`);
        setExchanges(data);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchExchanges();
  }, []);

  if (error) return <Error message={"Error while fetching exchanges"} />;

  return (
    <Container
      maxW={"container.xl"}
      bgColor={"blackAlpha.900"}
      p={{ base: "8", md: "16" }}
      pos="relative"
      overflow="hidden"
    >
      {/* Left decorative line */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "20px" }}
        transition={{ duration: 0.5 }}
        pos="absolute"
        top="0"
        left="-20px"
        h="100%"
        bgColor="whiteAlpha.600"
      />

      {/* Exchanges */}
      {loading ? (
        <Loader />
      ) : (
        <HStack
          wrap={"wrap"}
          justifyContent={"space-evenly"}
          spacing={{ base: "4", md: "8" }}
        >
          {exchanges.map((i) => (
            <ExchangeCard
              key={i.id}
              name={i.name}
              img={i.image}
              rank={i.trust_score_rank}
              url={i.url}
            />
          ))}
        </HStack>
      )}

      {/* Right decorative line */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "20px" }}
        transition={{ duration: 0.5 }}
        pos="absolute"
        top="0"
        right="-20px"
        h="100%"
        bgColor="whiteAlpha.600"
      />
    </Container>
  );
};

const ExchangeCard = ({ name, img, rank, url }) => (
  <a href={url} target={"blank"}>
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <VStack
        w={{ base: "44", md: "52" }}
        shadow={"lg"}
        borderRadius={"lg"}
        p={{ base: "4", md: "8" }}
        m={{ base: "2", md: "4" }}
        bgColor={"whiteAlpha.800"}
        css={{
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        <Image
          src={img}
          w={"10"}
          h={"10"}
          objectFit={"contain"}
          alt={`${name} Logo`}
        />
        <Heading size={"md"} noOfLines={"1"} textAlign="center">
          {rank}
        </Heading>
        <Text noOfLines={"1"} textAlign="center">
          {name}
        </Text>
      </VStack>
    </motion.div>
  </a>
);

export default Exchanges;
